import { useState } from "react";
import Cookies from "js-cookie";

import logo from "./logo.svg";
import "./App.css";
import "./style/default.css";

import banner from "./assets/products/35mm_film_colorprints_lab_template.jpg";
import pr_1 from "./photos/product_1.jpg";
import pr_2 from "./photos/product_2.jpg";
import pr_3 from "./photos/product_3.jpg";
import pr_4 from "./photos/product_4.jpg";

// Router
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
} from "react-router-dom";

// Components
import Services from "./components/Services";
import Products from "./components/Products";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Cart from "./components/Cart";
import PrivateRoute from "./components/PrivateRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPass from "./components/ForgotPass";
import ChangePass from "./components/ChangePass";
import Login from "./components/Login";

// Pages
import Product from "./pages/Product";
import ProductsPage from "./pages/Products";
import Homepage from "./pages/Homepage";
import Dashboard from "./pages/AdminDashboard";
import { useEffect } from "react";
import Filmstrip from "./components/Filmstrip";
import Order from "./pages/Order";
import Signin from "./pages/Signin";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Contact from "./pages/Contact";
import Layout from "./pages/Layout";
import NotFound from "./pages/NotFound";
import Confirmation from "./pages/Confirmation";
import Terms from "./pages/Terms";
import Policy from "./pages/Policy";

import AdminRoute from "./components/AdminRoute";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  const [refreshToken, setRefreshToken] = useState(null);
  useEffect(() => {
    const token = Cookies.get("refreshToken"); // Get the cookie value
    if (token) {
      setRefreshToken(token); // Update state with the cookie value
      setIsAuthenticated(true);
    }
  }, [refreshToken]); // Run this effect only once on mount

  return (
    <div className="App">
      <Router>
        <body>
          <Routes>
            {/* Routes that use Layout (Header + Footer) */}
            <Route path="/" element={<Layout />}>
              <Route exact path="/" element={<Homepage />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/catalogue" element={<ProductsPage />} />
              {}
              <Route
                path="/profile/:id"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              {/* <Route path="/cart" element={<Cart />} /> */}
              {/* Private Route */}
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <Cart />
                  </ProtectedRoute>
                }
              />
              {/* <Route exact path="/checkout" element={<Order />} /> */}
              <Route path="/contact" element={<Contact />}></Route>
              <Route
                path="/checkout"
                element={
                  <ProtectedRoute>
                    <Order />
                  </ProtectedRoute>
                }
              />{" "}
              <Route
                path="/order-confirmation"
                element={<Confirmation />}
              ></Route>
              <Route path="/terms-and-conditions" element={<Terms />}></Route>
              <Route path="/privacy-policy" element={<Policy />}></Route>
              <Route path="*" element={<NotFound />}></Route>{" "}
            </Route>
            <Route path="/auth" element={<Signin />}>
              <Route path="login" element={<Login />} />
              <Route path="forgot-password" element={<ForgotPass />} />
              <Route path="reset-password" element={<ChangePass />} />
            </Route>
            {/* <Route path="/signin" element={<Signin />} /> */}
            <Route path="/register" element={<Register />} />

            {/* Admin */}
            <Route path="admin/login" element={<AdminLogin />} />
            <Route
              path="admin/dashboard"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />
          </Routes>
        </body>
      </Router>
    </div>
  );
}

export default App;
